<template>
  <b-container fluid v-if="period_context_loaded">
    <b-row>
      <b-col lg="3" md="6" sm="12" class="p-0" v-for="(item, i) in PeriodCardsObject_1" :key="'item-1-' + i">
        <b-container v-if="item.condition" fluid class="pr-2 pb-4 pl-2">
          <card :info="item.info" :title="item.title" :showDiff="item.show_diff">
            <img v-if="item.diff == '[[ ga_icon ]]'" src="@/assets/logo-google-analytics.svg" width="40px" alt="img" slot="diff">
            <span v-else-if="item.diff > 0" slot="diff" :id="'item-id-1-' + i"
              style="font-weight: 600; margin-right: 6px;"
              v-b-tooltip.hover.left.html="tooltipMethod(item.diff_qtde)"
              class="text-base text-12"
            >+{{ item.diff }}%</span>
            <span v-else-if="item.diff != 0" slot="diff" :id="'item-id-1-' + i"
              style="font-weight: 600; margin-right: 6px;"
              v-b-tooltip.hover.left.html="tooltipMethod(item.diff_qtde)"
              class="text-base text-12"
            >{{ item.diff }}%</span>
            <img v-if="item.diff > 0" slot="arrow" width="11px" src="@/assets/increment_arrow.svg" alt="increment_arrow">
            <img v-if="item.diff < 0" slot="arrow" width="11px" src="@/assets/decrement_arrow.svg" alt="decrement_arrow">
            <div slot="image" :class="item.bg + ' img-box'">
              <img :src="require(`@/assets/${item.img}`)" alt="img">
            </div>
          </card>
        </b-container>
        <b-container fluid v-else-if="is_marketplace" class="pr-2 pb-4 pl-2">
          <card title="indisponível para marketplace">
            <div slot="image" :class="item.bg + ' img-box'">
              <img :src="require(`@/assets/${item.img}`)" alt="img">
            </div>
          </card>
        </b-container>
        <b-container fluid v-else class="pr-2 pb-4 pl-2">
          <card title="disponível apenas por loja">
            <div slot="image" :class="item.bg + ' img-box'">
              <img :src="require(`@/assets/${item.img}`)" alt="img">
            </div>
          </card>
        </b-container>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="3" md="6" sm="12" class="p-0" v-for="(item, i) in PeriodCardsObject_2" :key="'item-2-' + i">
        <b-container v-if="item.condition" fluid class="pr-2 pb-4 pl-2">
          <card :info="item.info" :title="item.title" :showDiff="item.show_diff">
            <img v-if="item.diff == '[[ ga_icon ]]'" src="@/assets/logo-google-analytics.svg" width="40px" alt="img" slot="diff">
            <span v-else-if="item.diff > 0" slot="diff" :id="'item-id-2-' + i"
              style="font-weight: 600; margin-right: 6px;"
              v-b-tooltip.hover.left.html="tooltipMethod(item.diff_qtde)"
              class="text-base text-12"
            >+{{ item.diff }}%</span>
            <span v-else-if="item.diff != 0" slot="diff" :id="'item-id-2-' + i"
              style="font-weight: 600; margin-right: 6px;"
              v-b-tooltip.hover.left.html="tooltipMethod(item.diff_qtde)"
              class="text-base text-12"
            >{{ item.diff }}%</span>
            <img v-if="item.diff > 0" slot="arrow" width="11px" src="@/assets/increment_arrow.svg" alt="increment_arrow">
            <img v-if="item.diff < 0" slot="arrow" width="11px" src="@/assets/decrement_arrow.svg" alt="decrement_arrow">
            <div slot="image" :class="item.bg + ' img-box'">
              <img :src="require(`@/assets/${item.img}`)" alt="img">
            </div>
            <span v-if="item.extra_info" class="extra-info-card" slot="extra_info">{{ item.extra_info }}</span>
          </card>
        </b-container>
        <b-container fluid v-else-if="is_marketplace" class="pr-2 pb-4 pl-2">
          <card title="indisponível para marketplace">
            <div slot="image" :class="item.bg + ' img-box'">
              <img :src="require(`@/assets/${item.img}`)" alt="img">
            </div>
          </card>
        </b-container>
        <b-container fluid v-else class="pr-2 pb-4 pl-2">
          <card title="disponível apenas por loja">
            <div slot="image" :class="item.bg + ' img-box'">
              <img :src="require(`@/assets/${item.img}`)" alt="img">
            </div>
          </card>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
  <loader-box v-else height="180px" class="mb-4 mr-2 ml-2"/>
</template>

<script>
// ============================ !!!IMPORTANTE !!! =============================
// Os "Diffs" não chegam formatados como os valores normais
import Card from '@/components/Card.vue'
import LoaderBox from '@/components/LoaderBox.vue'

export default {
  components: {
    Card,
    LoaderBox
  },
  computed: {
    is_marketplace() { return this.$store.getters.is_marketplace },
    period_context_loaded() { return this.$store.getters.period_context_loaded },
    PeriodCardsObject_1() { return this.$store.getters.PeriodCardsObject_1 },
    PeriodCardsObject_2() { return this.$store.getters.PeriodCardsObject_2 },
  },
  methods: {
    tooltipMethod(diff_qtde) {
      if (!diff_qtde) return

      var qtd = diff_qtde > 0 ? `qtde: + ${diff_qtde}` : `qtde: ${diff_qtde}`
      return `<span>comparado com o mesmo intervalo de tempo anterior</span><br>
              <span>${qtd}</span>`
    }
  }
}
</script>

<style>

</style>
